<style lang="less" scoped>
.verify_result{
	position: absolute;
	width: 100%;
	height: 100%;
	padding-bottom: 54px;
	box-sizing: border-box;
	display: -webkit-box; display:flex;
	-webkit-box-align: center; align-items: center;
	-webkit-box-pack: center; justify-content: center;
	flex-direction: column;
	.icon{
		width: 58px;
		margin-bottom: 22px;
	}
	h3{
		text-align: center;
		font-size: 18px;
		margin-bottom: 8px;
	}
	p{
		font-size: 12px;
		color: #999;
		padding-bottom: 80px;
		width: 55%;
		text-align: center;
		line-height: 18px;
	}
	.jump{
		width: 100%;
		text-align: center;
		position: fixed;
		left: 0;
		bottom: 80px;
		span, a{
			color: #999;
			font-size: 12px;
			font-weight: 700;
			color: #dc2a2a;
		}
	}
}
</style>

<template>
	<!-- Main verify_result -->
	<section class="verify_result">
		<img class="icon" src="../assets/success.png">
		<h3>恭喜，成功开通余额+</h3>
		<p>马上进行风险等级测评，更好地选择适合你的理财类型</p>
		<div class="jump">
			<router-link  class="toidentity" to="/evaluating" replace>风险等级测评</router-link>
		</div>
		<footbtn btn-txt="稳健型，直接赚钱" :is-on="isActive" v-on:next="next"></footbtn>
	</section>
</template>

<script>
	/*
		global Finish
		global track
	*/

	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import android from '@flyme/jr/js/android.js';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				identity: {
					status: ''
				},
				userInfo: {},
				loading: false
			};
		},
		computed: {
			isActive: function() {
				return true;
			}
		},
		components: {
			footbtn
		},
		created: function () {
			let _this = this;
			android('setTitle', {
				title: "开通余额+"
			});
			android('startLoading', {mes: '正在加载'});
			android('getUserInfo', {}, (d) => {
				_this.userInfo = d;
				_this.getIdentity();
			});
		},
		mounted: function () {
			android('addBackPressedListener', {}, this.jump);
			android('addBackPressedListener', {}, this.jump);
		},
		methods: {
			getIdentity: function () {
				let _this = this;
				axios.post(apis.identity_img_query, {
					show_type: 1,
					sys_reserved_info: '{"uid": '+ _this.userInfo.userId +'}'
				}).then(function(d) {
					android('stopLoading');
					console.log('identity_img_query', d, d.value.detail_info);
					// if (d.value.status == 30) {
					// 	android('addBackPressedListener', {}, _this.jump);
					// 	android('addBackPressedListener', {}, _this.jump);
					// }
					_this.identity = d.value;
				});
			},
			next: function () {
				let _this = this;

				android('showLoadingDialog', {
					mes: '正在加载'
				});

				axios.post(apis.risk_grade_evaluate, {
					type: 2
				}).then(function(d) {
					console.log('risk_grade_evaluate', d);
					_this.$router.replace({path: '/acctplus'});
					android('hideLoadingDialog');
				});
			},
			jump: function () {
				console.log('this.identity.status', this.identity.status);
				if (this.identity.status == 30) {
					android('startPage', {
						url: config.staticURL + '/#/acctplus',
						start_type:1,
						data:'',
						display:{
							title:'余额+'
						}
					});
					Finish('Verify_result');
				}else{
					Finish();
				}
			},
			refresh: function () {
				android('startLoading', {mes: '正在加载'});
				setTimeout(function () {
					this.getIdentity();
				}.bind(this), 300)
			},
			again: function () {
				track('event_ecash_identity_faild');
				this.$router.replace({path: '/verify'});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Verify_result.vue